module.exports = __webpack_public_path__ + "img/prop-tv-2-left.851dfa27.png";